import React, { useEffect } from "react";
import OfferDetailsBread from "../Assets/img/offer-page/offer-details-two-bred-bg.png";
import OfferDetailsImg from "../Assets/img/offer-page/offer-details-img-2.png";
import { Link } from "react-router-dom";

const OfferDetails2 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Breadcrumbs --> */}
      <section
        className="breadcrumbs offer-details-two-bread"
        style={{ backgroundImage: `url(${OfferDetailsBread})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Link to="/offerpage" className="offer-details-two-bred-back">
                <i className="fi-rr-angle-small-left"></i>Back to previous
              </Link>
            </div>
            <div className="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-12">
              <div className="offer-details-two-content">
                <h1 className="offer-details-two-cont-title">
                  OFFER: 10% OFF for Every New User
                </h1>
                <span to="#" className="offer-details-bred-btn">
                  Deadline: 30 April, 2022
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End Breadcrumbs --> */}

      <section className="offer-details-two-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="offer-details-two-main">
                <p>
                  Pellentesque egestas scelerisque amet vestibulum, nisl
                  interdum turpis nam. Eget vel maecenas consectetur diam nulla
                  id ultrices lorem vulputate. Dui tellus luctus feugiat
                  pellentesque. At gravida eu egestas ut placerat sed enim. Non
                  tempor ut amet proin volutpat proin donec neque. Amet, lorem
                  facilisis tristique quis tempus, eu, varius lobortis.
                  Vulputate libero eu tincidunt sit lacus. Quisque vel feugiat
                  sit viverra. Pharetra mauris sed platea accumsan.{" "}
                </p>
                <p>
                  Eget lacinia fames pellentesque tortor. Metus gravida elit
                  molestie vitae eu mus. Tellus diam in ipsum sed. Nisi et
                  pulvinar eu, in dolor. Rhoncus est, elementum magna odio et ut
                  feugiat phasellus amet. Sed sapien felis, sit mattis varius
                  massa. Consectetur elementum pretium blandit sed sed ultrices
                  vitae vitae. Netus et nibh quisque nec sed risus laoreet. Quis
                  tristique vitae rhoncus ultrices molestie tellus. Nascetur
                  mauris sagittis turpis mauris arcu vitae elit.
                </p>
                <ul className="offer-details-two-list">
                  <li>
                    In sit quis ut ultricies ipsum vel varius. Sed purus at in
                    lorem.
                  </li>
                  <li>
                    Enim non malesuada egestas facilisi. Est purus tempus amet
                    lacus magna.
                  </li>
                  <li>Velit habitasse leo sed augue nulla interdum.</li>
                  <li>
                    Blandit mauris auctor mauris nunc tellus molestie amet.
                  </li>
                </ul>
                <div className="offer-details-two-cont-img">
                  <img src={OfferDetailsImg} alt="#" />
                </div>
                <div className="offer-details-two-content-btn">
                  <Link to="#" className="theme-btn">
                    <i className="fi-rr-arrow-right"></i>Grab it now
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OfferDetails2;
